import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  gap: var(--medium-gap);
  flex-grow: 1;
  width: 100%;
  height: 100%;
`;

export const TabWrapper = styled.div`
  flex-grow: 1;
  width: 100%;
  display: flex;
  overflow: hidden;

  flex-direction: column;
  justify-items: center;
  gap: var(--small-gap);
  align-items: flex-start;

  .container-content {
    padding: 10px 30px;
    width: 100%;
    box-sizing: border-box;
    table {
      border-collapse: collapse;
      border-spacing: 0;
      border: 1px solid #ddd;
      width: 100%;
      max-width: 100%;
      margin-bottom: 19px;
      &.table-striped > tbody > tr:nth-of-type(2n + 1) {
        background-color: #f7f8fa;
      }
      &.solid-bg {
        background-color: #f7f8fa;
      }
      td,
      th {
        padding: 8px;
        line-height: 1.2;
        vertical-align: top;
        border: 1px solid #ddd;
      }
    }
  }
`;

export const Tab = styled.div`
  color: rgba(0, 0, 0, 0.87);
  position: relative;

  /* Show the red dot only if parent does NOT have class 'active' */
  .dsc-tab:not(.active) &::after {
    content: '';
    position: absolute;
    top: -4px;
    right: -10px;
    width: 8px;
    height: 8px;
    background-color: var(--mainPink);
    border-radius: 50%;
  }
`;

export const ContentContainer = styled.div`
  background-color: var(--white);
  border-radius: var(--main-card-radius);
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: 100%;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 16px;
`;

/* Preparation for when the URL is ready
export const IFrame = styled.iframe.attrs({ width: '100%', height: '100%', referrerPolicy: 'no-referrer' })`
  border: unset;
  flex-grow: 1;
`;
*/
